// extracted by mini-css-extract-plugin
export default {"form-control":"Input_form-control__uk2GX","error":"Input_error__OcT3j"};